import { UPDATE_ROL, RESET_ROL } from "./actionTypes";
import * as Yup from "yup";
const rolBase = {
  id: "",
  name: "",
  description: "",
  models: [],
};

const initialState = {
  rol: { ...rolBase },
  rolValidations: {
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
  },
};

const rol = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ROL:
      // Actualizar el estado
      return {
        ...state,
        rol: action.payload,
      };
    case RESET_ROL:
      // Actualizar el estado
      return {
        ...state,
        rol: { ...rolBase },
      };
    default:
      return state;
  }
};

export default rol;
